import { Component, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MenuService } from '../../../services/menu.service';
import { PanelModule } from '../../../modules/panel.module';

@Component({
  selector: 'brt-menu-item-option-choice-price',
  templateUrl: './menu-item-option-choice-price.component.html',
  standalone: true,
  imports: [PanelModule],
  styleUrl: './menu-item-option-choice-price.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MenuItemOptionChoicePriceComponent),
      multi: true
    }
  ]
})
export class MenuItemOptionChoicePriceComponent {
  options: any[];
  businessId: string;
  constructor(route: ActivatedRoute, menuService: MenuService) {
    route.params.subscribe(async params => {
      this.businessId = params['bid'];
      menuService.searchMenuOption({ BusinessId: this.businessId }).then(result => this.options = result.List);
    });
  }

  value: any[];

  addItem() {
    this.value.push({});
    this.onChange(this.value);
  }
  removeItem(index: number) {
    this.value.splice(index, 1);
    this.onChange(this.value);
  }

  makePricesSame(item: any) {
    const price = item.Price ?? item.DeliveryPrice ?? item.PickupPrice ?? item.DineInPrice ?? 0;
    item.Price = price;
    item.DeliveryPrice = price;
    item.PickupPrice = price;
    item.DineInPrice = price;
    this.onChange(this.value);
  }

  writeValue(value: any[]) { this.value = value || []; }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  onChange = (_: any[]) => { };
  onTouched = () => { };
}
